import React, { useImperativeHandle } from 'react'

import { Modal, Form, Input } from 'antd'

import ShoeCard from '../ShoeCard'

const ShoesRequestForm = React.forwardRef(
  (
    { visible, onCancel, onCreate, image, productName, SKU, confirmLoading },
    ref,
  ) => {
    const [form] = Form.useForm()

    useImperativeHandle(ref, () => ({
      form,
    }))

    return (
      <Modal
        visible={visible}
        title={`Order ${productName} for a client (${SKU})`}
        okText="Request item"
        onCancel={onCancel}
        onOk={onCreate}
        confirmLoading={confirmLoading}
        centered
      >
        <ShoeCard
          image={image}
          name={productName}
          value={SKU}
          zoom={false}
          style={{ marginBottom: '1rem' }}
        />
        <Form
          form={form}
          layout="horizontal"
          labelCol={{
            xs: { span: 24 },
            sm: { span: 8 },
          }}
          wrapperCol={{
            xs: { span: 24 },
            sm: { span: 16 },
          }}
        >
          <Form.Item label="Customer first name" name="customerFirstName">
            <Input type="text" />
          </Form.Item>
          <Form.Item label="Customer last name" name="customerLastName">
            <Input type="text" />
          </Form.Item>
          <Form.Item
            label="Customer email"
            extra="Check this email address with the client!"
            name="customerEmail"
            rules={[
              {
                type: 'email',
                message: 'The input is not valid email',
              },
              {
                required: true,
                message: "Please enter customer's email",
              },
            ]}
          >
            <Input type="email" />
          </Form.Item>
          <Form.Item
            label="Customer phone"
            name="customerPhone"
            rules={[
              {
                min: 7,
                message: 'Phone must be at least 7 characters',
              },
            ]}
          >
            <Input type="tel" />
          </Form.Item>
          <Form.Item
            label="Comments"
            name="comments"
            rules={[
              {
                required: true,
                message: 'Please enter a comment',
              },
            ]}
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Modal>
    )
  },
)

export default ShoesRequestForm
